import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';

@Component({
  selector: 'app-pirority-offer',
  templateUrl: './pirority-offer.component.html',
  styleUrls: ['./pirority-offer.component.scss']
})
export class PirorityOfferComponent implements OnInit {

  @Input() club: ClubDetails;
  @Input() clubCode: string;
  @Input() userConnected: InfosUser;

  constructor(
    private dataService: DataService,
    private router: Router,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void { }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  goToPriorityOffersClub(): void {
    this.dataService.showDetailsClubPriority$.next(true);
    this.dataService.clubCodePriorityOffer$.next(this.clubCode);
    this.dataService.clubPriorityOffer$.next(this.club);

    const queryParams = {
      admin: { clubCode: this.clubCode, clubName: this.club.clubName },
      club: null
    };

    this.router.navigate(['/admin/offer-priority'], { queryParams: queryParams[this.userConnected.role] });
  }
}
